export interface LearnWordsUsername {
  email?: string;
  username?: string;
  redirectUrl?: string;
}

export interface LearnWordsResponse {
  errors?: any[];
  succes?: boolean;
  url?: string;
  user_id?: string;
}
